import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  padding: 0 10px;
`

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-top: 28px;
  margin-bottom: 20px;
`

export const SearchSuffix = styled.span`
  display: inline-flex;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* Filho DIRETO de proposito: este rotulo e o <span> do proprio campo.
     Um 'span' solto tambem casaria com o <span> interno que o Select do
     Ant Design usa para exibir o valor escolhido — e o valor sairia com a
     cor do rotulo, mais apagada que o resto do texto. */

  > span {
    font-family: 'Poppins';
    font-size: 12px;
    color: ${colors.grey600};
  }
`

export const TableWrapper = styled.div`
  background: ${colors.surface};
  border-radius: 12px;
  padding: 16px;
  overflow-x: auto;

  tr {
    cursor: pointer;
  }

  /* Larguras previsiveis e quebra de conteudo longo dentro da coluna. */
  table {
    table-layout: fixed;
    margin-top: 0;
  }

  /* Alinhamento consistente: cabecalho e corpo a esquerda, centralizado na vertical. */
  table tbody td {
    padding: 14px 16px;
    vertical-align: middle;
    word-break: break-word;
  }
  table thead th {
    padding: 12px 16px;
    vertical-align: middle;
  }

  /* Larguras por coluna (Canal, Destinatario, Remetente, Cliente, Status, Usuario, Data/hora). */
  table thead th:nth-child(1),
  table tbody td:nth-child(1) {
    width: 9%;
    text-align: left;
    white-space: nowrap;
  }
  table thead th:nth-child(2),
  table tbody td:nth-child(2) {
    width: 15%;
    text-align: left;
  }
  table thead th:nth-child(3),
  table tbody td:nth-child(3) {
    width: 16%;
    text-align: left;
  }
  table thead th:nth-child(4),
  table tbody td:nth-child(4) {
    width: 20%;
    text-align: left;
  }
  table thead th:nth-child(5),
  table tbody td:nth-child(5) {
    width: 10%;
    text-align: left;
  }
  table thead th:nth-child(6),
  table tbody td:nth-child(6) {
    width: 17%;
    text-align: left;
  }
  table thead th:nth-child(7),
  table tbody td:nth-child(7) {
    width: 13%;
    text-align: left;
    white-space: nowrap;
  }
`

export const Tag = styled.span<{ background: string; color: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
`

// Celula de remetente: numero + de qual instancia saiu, ou a ausencia declarada.
export const Remetente = {
  Bloco: styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;

    /* O número não quebra entre o DDD e o resto (a tabela usa word-break: break-word). */
    > span:first-child {
      white-space: nowrap;
    }
  `,
  Origem: styled.span`
    font-size: 12px;
    color: ${colors.grey600};
  `,
  Ausente: styled.span`
    font-size: 13px;
    font-style: italic;
    color: ${colors.grey600};
  `,
}
